'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdCopyright = function MdCopyright(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20 33.4c7.3 0 13.4-6.1 13.4-13.4s-6.1-13.4-13.4-13.4-13.4 6.1-13.4 13.4 6.1 13.4 13.4 13.4z m0-30c9.2 0 16.6 7.4 16.6 16.6s-7.4 16.6-16.6 16.6-16.6-7.4-16.6-16.6 7.4-16.6 16.6-16.6z m-0.2 11.8c-2.4 0-3.2 2.2-3.2 4.6v0.4c0 2.4 0.8 4.6 3.2 4.6 1.4 0 2.7-0.9 2.7-2.4h3c0 1.5-0.9 2.7-1.8 3.5-1 0.8-2.1 1.4-3.9 1.4-4.3 0-6.4-2.8-6.4-7.1v-0.4c0-2 0.5-3.9 1.5-5 1.1-1.2 2.7-2.1 4.9-2.1 1.7 0 3.1 0.6 4 1.4 0.9 0.9 1.7 2.2 1.7 3.9h-3c0-0.4-0.1-0.7-0.2-1s-0.4-0.7-0.6-1c-0.4-0.4-1.1-0.8-1.9-0.8z' })
        )
    );
};

exports.default = MdCopyright;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/copyright.js
// module id = 2207
// module chunks = 0